dirtyDateToCompare